export default __webpack_public_path__ + "img/99e3a1c4ba735283d0cf08fdf643596a.png";